import { HTTP } from '@/services/http'
import ProductTypeFactory from '../domain/services/ProductTypeFactory'

const URL = 'api/product-types'

export function fetchAll () {
  return HTTP.get(URL)
    .then(response => response.data.collection.map(productType => ProductTypeFactory.get(productType)))
}
